<div *ngFor="let field of field.fieldGroup">
  <formly-field class="col" [field]="field"></formly-field>
</div>
